import {mapGetters, mapMutations} from 'vuex';
import {
    SET_DATA_REMOVE_FROM_BASKET,
    SHOW_POPUP_EDIT_TO_BASKET,
    SET_EDIT_BASKET_ITEM,
    SHOW_POPUP_REMOVE_FROM_BASKET,
    INCREMENT_BASKET_LIST_COUNT,
    DECREMENT_BASKET_LIST_COUNT,
    SET_BASKET_LIST_COUNT,
    FRESH_BASKET_ITEMS
} from '@/store/mutation-types';

import Moment from 'moment';
import {extendMoment} from 'moment-range';
import _ from "lodash";

const moment = extendMoment(Moment);

export default {
    name: 'basket',
    breadcrumb() {
        return {
            label: this.$t('basket'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                }
            ]
        }
    },
    data(){
        return {
            disableButton: false,
            params: {
                title: '',
                description: '',
                keywords: '',
                image: ''
            },
        }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    computed: {
        ...mapGetters({
            basketList: 'basket/basket',
            user: 'profile/user',
            isAuthenticated: `auth/isAuthenticated`,
        }),
        totalPrice() {
            let price = 0;
            if(this.isAuthenticated){
                if(this.user.inner){
                    this.basketList.forEach(e => {
                        const remainder = e.days % 60;
                        const iterationValue = (e.days - remainder) / 60;
                        const amountWithIterations = (iterationValue * (e.price / 2)) * e.selectCount;
                        price = price + amountWithIterations;
                        const amountRemainder = remainder * e.price_rent;
                        if(amountRemainder >= (e.price / 2) ){
                            price = price + ((e.price / 2) * e.selectCount);
                        }else{
                            price = price + (amountRemainder * e.selectCount);
                        }
                    });
                }else{
                    this.basketList.forEach(e => {
                        price = price + e.totalPrice;
                    });
                }
            }else{
                this.basketList.forEach(e => {
                    price = price + e.totalPrice;
                });
            }

            return price;
        },
        showWarrantyPrice(){
            if(this.isAuthenticated){
                if(!this.user.inner){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        },
        totalWarrantyPrice(){
            let price = 0;
            if(this.isAuthenticated){
                if(!this.user.inner){
                    this.basketList.forEach(e => {
                        price = price + e.warrantyAmount;
                    });
                }
            }else{
                this.basketList.forEach(e => {
                    price = price + e.warrantyAmount;
                });
            }
            return price;
        }
    },
    created(){
        moment.locale(this.$route.params.lang);
        this.freshBasket();
    },
    methods: {
        ...mapMutations({
            changePopupEditBasket: `basket/${SHOW_POPUP_EDIT_TO_BASKET}`,
            setEditItem: `basket/${SET_EDIT_BASKET_ITEM}`,
            changeShowRemovePopup: `basket/${SHOW_POPUP_REMOVE_FROM_BASKET}`,
            changeDataRemoveItemBasket: `basket/${SET_DATA_REMOVE_FROM_BASKET}`,
            increment: `basket/${INCREMENT_BASKET_LIST_COUNT}`,
            decrement: `basket/${DECREMENT_BASKET_LIST_COUNT}`,
            setCount: `basket/${SET_BASKET_LIST_COUNT}`,
            freshBasket: `basket/${FRESH_BASKET_ITEMS}`,
        }),
        addCount(obj, index){
            obj.index = index;
            this.increment(obj);
        },
        removeCount(obj, index){
            obj.index = index;
            this.decrement(obj);
        },
        getRangeDates(startDate, endDate, type='days'){
            let
                range = moment.range(startDate, endDate),
                array = Array.from(range.by(type));

            return array.map(e => {
                return e.format("YYYY-MM-DD");
            });
        },
        goCreateOrder(){
            let valid= true;
            let validDate = true;
            this.basketList.forEach(e => {
               if(e.selectCount > e.total_count){
                   valid = false;
               }
               let dayFrom = e.from;
                let nowDate = moment(new Date());
                let endDate = moment(dayFrom)
                var days = endDate.diff(nowDate, 'days');
                if( days < 0 ){
                    validDate = false;
                }

            });
            if(valid && validDate){
                this.$router.push({ name: 'create-order' });
            }
            if(!valid) {
                this.$toasted.error(this.$t('selectValidCount')).goAway(5000);
            }
            if(!validDate) {
                this.$toasted.error('Дата начала аренды товара не может быть меньше текущей даты.').goAway(7000);
            }
        },
        setValidValue: _.debounce(function(val, index, obj){
            obj.index = index;
            obj.selectCount = parseInt(val);
            if(parseInt(val)){
                if(parseInt(val) > 0 && parseInt(val) <= obj.total_count){
                    this.setCount(obj);
                }else{
                    if(obj.total_count < parseInt(val)){
                        this.$nextTick(() => {
                            obj.selectCount = obj.total_count;
                            this.setCount(obj);
                        })
                    }
                }
            }else{
                obj.selectCount = 1;
                this.setCount(obj);
            }
        }, 1000),
        removeFromBasket(index, id) {
            this.changeShowRemovePopup(true);
            const obj = {
                index: index,
                id: id
            };
            this.changeDataRemoveItemBasket(obj);
        },
        replaceDateMoment(date) {
            return `${moment(date).format("MMMM DD").charAt(0).toLocaleUpperCase()}${moment(date).format("MMMM DD").slice(1)}`
        },
        editItem(item, index) {
            this.changePopupEditBasket(true);
            this.setEditItem({...item, index: index});
        },
    }
}
